import type { BenchmarkRun } from "./data/types";

export const RecentRuns = ({ runs, error, onSelect, onNewRun }: {
  runs: BenchmarkRun[];
  error: string | null;
  onSelect: (id: string) => void;
  onNewRun: () => void;
}) => (
  <section className="mb-4 rounded-lg border p-4">
    <div className="flex flex-wrap items-center justify-between gap-2">
      <h2 className="font-semibold">Recent benchmark runs</h2>
      <button className="stt-btn stt-btn--secondary" onClick={onNewRun}>Compare STT providers</button>
    </div>
    <p className="mb-3 text-xs text-muted-foreground">Choose providers and preview a run against the existing dataset. Each run keeps its own dataset, split and evaluation results.</p>
    {error && <p role="alert" className="text-sm text-destructive">Could not refresh runs: {error}</p>}
    {runs.length === 0 && !error && <p className="text-sm text-muted-foreground">No benchmark runs yet.</p>}
    <div className="space-y-2">
      {runs.slice(0, 5).map((run) => (
        <button key={run.run_id} onClick={() => onSelect(run.run_id)} className="flex w-full flex-wrap items-center gap-x-4 gap-y-1 rounded border p-3 text-left text-sm hover:bg-muted">
          <span className="font-medium">{run.config.dataset_version} · {run.config.splits.join(", ")}</span>
          <span>{run.sample_count} samples</span>
          <span>{run.status.replaceAll("_", " ")} · {run.completed_cells}/{run.total_cells} cells</span>
          <time className="text-xs text-muted-foreground" dateTime={run.updated_at}>Updated {new Date(run.updated_at).toLocaleString()}</time>
          <span className="w-full text-xs text-muted-foreground">{run.config.provider_keys.join(", ")}</span>
        </button>
      ))}
    </div>
  </section>
);
